import { MoneyConnectClientAPI } from "./axios-service-creator";

export const LoggingAPI = {
  error: payload => MoneyConnectClientAPI.post("/permission/log", payload),
};
